import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import React from "react";
import ScrollIndicatorsComp from "../ScrollIndicatorsComp/ScrollIndicatorsComp";
import { ColumnStyle, LayoutContainerStyle } from "./styled";

interface IColumn {
  rows: JSX.Element[],
  maxButtonImages?: number
}

const Column = ({
  rows,
  xs,
  sm,
  md,
  lg
}: {
  rows: JSX.Element[],
  xs?: number,
  sm?: number,
  md?: number,
  lg?: number,
}) => {
  return (
    <Grid
      item
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      sx={ColumnStyle}
      data-automation="board-col"
    >
      {rows && rows.length > 0 && rows.map((row, index) => (
        <React.Fragment key={index}>{row}</React.Fragment>
      ))}
    </Grid>
  );
};

export const BoardLayout = ({
  columns,
  xs = 12,
  sm = 5.7,
  md = 4.7,
  lg = 3.7,
  containerRef
}: {
  columns: IColumn[],
  xs?: number,
  sm?: number,
  md?: number,
  lg?: number,
  containerRef?: React.RefObject<HTMLDivElement>,
}) => {
  return (
    <Typography
      sx={{ padding: { xs: 1, sm: "2px" } }}
      component={'div'}
      variant='container'
      data-automation="data-container"
    >
      <ScrollIndicatorsComp ref={containerRef}>
        <Grid container sx={LayoutContainerStyle} ref={containerRef}>
          {columns && columns.length > 0 &&
            columns.map((column, i) => (
              <Column
                key={i}
                rows={column.rows}
                // Setting the `xs` (extra-small screen size) breakpoint value based on `maxButtonImages`.
                // If `maxButtonImages` is undefined, use the default `xs` value.
                // Otherwise, adjust based on the value of `maxButtonImages`:
                // - If `maxButtonImages` is 0 or 1, set `xs` to 5
                // - For any other case (2 or more), set `xs` to 6
                xs={column.maxButtonImages === undefined ? xs : (
                  column.maxButtonImages > 1 ? 6 : 5
                )}

                // Setting the `sm` (small screen size) breakpoint value based on `maxButtonImages`.
                // If `maxButtonImages` is undefined, use the default `sm` value.
                // Otherwise, adjust based on the value of `maxButtonImages`:
                // - If `maxButtonImages` is 0 or 1, set `sm` to 3
                // - For any other case (2 or more), set `sm` to 4
                sm={column.maxButtonImages === undefined ? sm : (
                  column.maxButtonImages > 1 ? 4 :  3 

                )}
                md={column.maxButtonImages === undefined ? md : (
                  column.maxButtonImages > 1 ? 4 : 3 

                )}
                lg={column.maxButtonImages === undefined ? lg : (
                  column.maxButtonImages > 1 ? 4 : 3 
                )}
              />
            ))}
        </Grid>
      </ScrollIndicatorsComp>
    </Typography>
  );
}
